import { BundleKey } from "./../../translation/bundleKey";
import * as yup from "yup";

export const entrantDetailSchema = (translate: any) => {
  const schema = yup.object().shape({
    firstname: yup.string().required(translate(BundleKey.ERROR_FIRSTNAME_MUST)),
    lastname: yup.string().required(translate(BundleKey.ERROR_LASTNAME_MUST)),
    countryCode: yup.string().required(translate(BundleKey.ERROR_COUNTRY_MUST)),
    dni: yup.string().required(translate(BundleKey.ERROR_DNI_MUST)),
  });
  return schema;
};
